import { render, staticRenderFns } from "./IpsIcon.vue?vue&type=template&id=a525d986"
import script from "./IpsIcon.vue?vue&type=script&lang=js"
export * from "./IpsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports